import { Logger } from './logging/logger';

const DEFAULT_SCRIPT_ID = 'reactjs-customerIO';

const logger = Logger.create('customerIo');

interface CustomerIO {
  identify: (memberId: string) => void;
  reset: () => void;
}

const getScript = (apiKey: string, siteId: string) => `
  (function(){
    // --- CLEANUP OLD SEGMENT/ANALYTICS.JS DATA ---
    try {
      var expired = "Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax; Secure";
      var domains = [location.hostname, ".everproedge.com", ".everpro.servicenation.com"];
      var keys = ["ajs_user_id", "ajs_anonymous_id", "ajs_group_id"];
      domains.forEach(function(domain){
        keys.forEach(function(key){
          document.cookie = key + "=; " + expired + "; Domain=" + domain;
        });
      });
      keys.forEach(function(k){ localStorage.removeItem(k); });
    } catch(e) {
      console.warn("Cleanup of legacy ajs_* cookies failed", e);
    }

    // --- STANDARD ANALYTICS.JS LOADER ---
    var analytics = window.analytics = window.analytics || [];
    if (!analytics.initialize) {
      if (analytics.invoked) { console.error("Snippet included twice."); return; }
      analytics.invoked = true;
      analytics.methods = ["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];
      analytics.factory = function(m){ return function(){ var a=[].slice.call(arguments); a.unshift(m); analytics.push(a); return analytics; }; };
      for (var i=0;i<analytics.methods.length;i++){ var key=analytics.methods[i]; analytics[key]=analytics.factory(key); }
      analytics.load = function(key, opts){
        var s=document.createElement("script"); s.type="text/javascript"; s.async=true;
        s.src="https://cdp.customer.io/v1/analytics-js/snippet/" + key + "/analytics.min.js";
        var n=document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(s,n);
        analytics._writeKey=key; analytics._loadOptions=opts;
      };
      analytics.SNIPPET_VERSION="4.15.3";

      analytics.load("${apiKey}", {
        storage: "localStorage",
        cookie: { sameSite: "Lax", secure: true },
        integrations: { "Customer.io In-App Plugin": { siteId: "${siteId}" } }
      });

      // --- IF NEW TAB WITH DIFFERENT SUB DOMAIN (ENV) CREATE A NEW ANONYMOUS ID ---
      analytics.ready(function(){
        if (typeof analytics.user === 'function') {
          if (!analytics.user().anonymousId()) {
            try { analytics.setAnonymousId(crypto.randomUUID()); } catch(_){}
          }
        }
        analytics.page();
      });
    }
  })();
`;

export const ReactCustomerIO = {
  initialize() {
    const apiKey = process.env.REACT_APP_CUSTOMER_IO_API_KEY;
    const siteId = process.env.REACT_APP_CUSTOMER_IO_SITE_ID;
    if (!apiKey || !siteId) {
      return;
    }

    if (!document) {
      return;
    }

    const hasScript = !!document.getElementById(DEFAULT_SCRIPT_ID);
    if (hasScript) {
      return;
    }

    logger.debug(Logger.format('loading customer.io script'));

    const script = document.createElement('script');

    script.innerHTML = getScript(apiKey, siteId);
    script.type = 'text/javascript';
    script.id = DEFAULT_SCRIPT_ID;
    script.async = true;

    document.body.appendChild(script);
  },
  identify(memberId: string) {
    const customerIO = (window as unknown as { analytics: CustomerIO })
      .analytics;
    if (!customerIO) {
      return;
    }
    try {
      logger.debug(Logger.format('Identifying user in customer.io', memberId));
      customerIO.identify(memberId);
    } catch (e) {
      logger.error(Logger.format('Error identifying user in customer.io', e));
    }
  },
  reset() {
    const customerIO = (window as unknown as { analytics: CustomerIO })
      .analytics;
    if (!customerIO) {
      return;
    }
    try {
      logger.debug(Logger.format('Logging out user in customer.io'));
      customerIO.reset();
    } catch (e) {
      logger.error(Logger.format('Error logging out user in customer.io', e));
    }
  },
};
